type RutValidation =
    "OK"
  | "Dígito verificador incorrecto"
  | "Rut inválido";

export function validateRut(s: string): RutValidation {
  const p = parseRut(s);
  if (p == null) {
    return "Rut inválido";
  }

  const [digits, dv] = p;
  if (computeDV(digits.map(Number)) !== dv) {
    return "Dígito verificador incorrecto";
  }

  return "OK";
}

export function formatRut(s: string): string {
  const [digits, dv] = parseRut(s)!;
  const withDots = Number(digits.join('')).toLocaleString('es-CL');
  return `${withDots}-${dv}`;
}



function parseRut(s: string): [string[], string] | null {
  s = s.trim().toUpperCase();
  const withDots = /^(\d?)(\d)\.(\d)(\d)(\d).(\d)(\d)(\d)-([0-9K])$/;
  const withoutDots = /^(\d?)(\d)(\d)(\d)(\d)(\d)(\d)(\d)-([0-9K])$/;
  const match = withDots.exec(s) ?? withoutDots.exec(s);
  if (match) {
    let [, ...digits] = match;
    const dv = digits.pop()!;
    return [digits, dv];
  } else return null;
}

function computeDV(digits: number[]): string {
  let factors: number[] = [];
  while (factors.length < digits.length) {
    factors.push(2, 3, 4, 5, 6, 7);
  }

  let sum = 0;
  digits.reverse().forEach((digit, i) => {
    sum += digit * factors[i];
  });

  const dv = 11 - (sum % 11);
  if (dv === 11) return '0';
  if (dv === 10) return 'K';
  return dv.toString();
}



console.assert(validateRut("19.208.834-8") === "OK");
console.assert(validateRut("19.208.834-9") === "Dígito verificador incorrecto");
console.assert(validateRut("19208834-8") === "OK");
console.assert(validateRut("12.345.684-K") === "OK");
console.assert(validateRut("12.345.684-k") === "OK");
console.assert(validateRut("12.345.689-0") === "OK");
console.assert(validateRut("1.234.569-0") === "OK");
console.assert(validateRut("1234569-0") === "OK");
console.assert(validateRut("19.208.834-G") === "Rut inválido");
console.assert(validateRut("19.208.834-80") === "Rut inválido");
console.assert(validateRut("K19.208.834-8") === "Rut inválido");
console.assert(validateRut("19-208-834-8") === "Rut inválido");
console.assert(validateRut("19.208834-8") === "Rut inválido");
console.assert(validateRut("19.2088.34-8") === "Rut inválido");